import React, { useEffect, useState ,lazy, Suspense} from "react";
import zynthtext from "../../assets/zynth-text.png";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import {
  FaUser,
  FaPlus,
  FaSyncAlt,
} from "react-icons/fa";
import UserProfileModal from "./userProfile";
import { useNavigate } from "react-router-dom";
// import RewriteRefinePanel from "./RewriteRefinePanel";
// import ToneAudiencePanel from "./ToneAudiencePanel";
// import ImageGeneratorPanel from "./Imagegeneratorpanel";
// import ImageSearchPanel from "./imagesearchpanel";
import { FaEdit } from "react-icons/fa";
import {RefinePresentationSkeleton} from '../skeletons/RefinePresentationSkeleton'
import RefineSkeleton from '../skeletons/RewriteRefinePanelSkeleton';
import { Theme } from "../../lib/theme";
const RewriteRefinePanel = lazy(() =>
  new Promise<{ default: React.ComponentType<any> }>((resolve) => {
    setTimeout(() => {
      import('./RewriteRefinePanel').then((module) => {
        resolve({ default: module.default });
      });
    }, 3000);
  })
);

const ToneAudiencePanel = lazy(() => import('./ToneAudiencePanel'));
const ImageGeneratorPanel = lazy(() => import('./Imagegeneratorpanel'));
const ImageSearchPanel = lazy(() => import('./imagesearchpanel'));

export default function RefinePresentation() {
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [position, setPosition] = useState<number>(1);
  const authToken = sessionStorage.getItem("authToken") || "";
  const [outlineId, setOutlineId] = useState<string>("");
  const [slideDataId, setSlideDataId] = useState<string>("");
  const [sectionName, setSectionName] = useState<string>("");
  const [formID, setFormID] = useState<string | null>(null);
  const [slideId, setSlideId] = useState<string | null>(null);
  const [showProfile, setshowProfile] = useState(false);
  const [planName, setPlanName] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [pptCountMonthly, setPptCountMonthly] = useState<number>(0);
  const [credits, setCredits] = useState<number>(0);

  const navigate = useNavigate();
  const orgId = sessionStorage.getItem("orgId");
const [isGenSlideValid, setIsGenSlideValid] = useState(false);
const [presentationExists, setPresentationExists] = useState<boolean | null>(null);
const [fallbackFormID, setFallbackFormID] = useState<string | null>(null);
const [submitLoading, setSubmitLoading] = useState(false);
const [activeRefineMode, setActiveRefineMode] = useState<"rewrite" | "tone" | "image-generate" | "image-search" | null>(null);
const [slideLimitReached,setSlideLimitReached] = useState(false)
const [slideLimitReachedToolTip,setSlideLimitReachedToolTip]=useState(false)
const generateDocumentID = () => {
    return "Document-" + Date.now();
  };


useEffect(() => {
  if (!authToken) {
    navigate("/login");
  }
}, [authToken, navigate]);

useEffect(()=>{
  const fetchNoOfSlides=async()=>{
  const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/getslides`;
  setLoading(true);
  try{
    const response = await axios.post(requestUrl,{
      PresentationID:sessionStorage.getItem('presentationId')
    },
  {
    headers: {
        Authorization: `Bearer ${authToken}`,
       },
  })
      if (response.status !== 200) {
        throw new Error("Failed to fetch organization data");
      }

      const data = response.data;
      if(!(data.slides <20) ){
        setSlideLimitReached(true);
        toast.error("Slide limit reached. Please upgrade to add more slides.")
        
      }
  }
  catch(error){
 console.error("Error fetching slides: ", error);
  }
  finally {
      setLoading(false);
    }
  }
  fetchNoOfSlides();

},[])

  const fetchOrganizationData = async () => {
    if (!orgId) {
      console.error("Error: Organization ID is missing.");
      return;
    }

    setLoading(true);
    const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

    try {
      const response = await axios.get(requestUrl, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch organization data");
      }

      const data = response.data;
      if (data?.plan?.plan_name) {
        setPlanName(data.plan.plan_name);
      }
      if (data?.credits !== undefined) {
  setCredits(data.credits);
}

      if (data?.pptcount_monthly !== undefined) {
        setPptCountMonthly(data.pptcount_monthly);
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizationData();
  }, []);

  const generateOutlineID = () => `outlineID-${window.crypto.randomUUID()}`;

const handleUpgrade = () => {
  const authToken = sessionStorage.getItem("authToken");
  const userEmail = sessionStorage.getItem("userEmail");
  const orgId = sessionStorage.getItem("orgId");

  const query = new URLSearchParams({
    authToken: authToken || "",
    userEmail: userEmail || "",
    orgId: orgId || "",
  });

  window.open(`/pricing?${query.toString()}`, "_blank", "noopener,noreferrer");
};


  const handleCreatePresentation = () => {
    window.parent.postMessage({ type: "openPptModal" }, "*");
  };

  const handleAddNewSlide = () => {
    setShowModal(true);
  };

  // useEffect(() => {
  //   const handleMessage = (event: MessageEvent) => {
  //     if (event.data?.type === "slideId") {
  //       const receivedSlideId = event.data.slideId;
  //       setSlideId(receivedSlideId);

  //       fetch("https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/slidedisplay/get-slide-info", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //         body: JSON.stringify({ GenSlideID: receivedSlideId }),
  //       })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (data?.FormID && data?.outline_id) {
  //           setFormID(data.FormID);
  //           setOutlineId(data.outline_id);
  //           setSlideDataId(data.slideData_id);
  //           setSectionName(data.SectionName);
  //           setIsGenSlideValid(true);  // ✅ valid GenSlideID
  //         } else {
  //           setIsGenSlideValid(false); // ❌ invalid GenSlideID
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching slide info:", error);
  //         setIsGenSlideValid(false);
  //       });

          
  //     }
  //   };

  //   window.addEventListener("message", handleMessage);
  //   return () => window.removeEventListener("message", handleMessage);
  // }, []);
useEffect(() => {
  const handleMessage = (event: MessageEvent) => {
    if (event.data?.type === "slideId") {
      const receivedSlideId = event.data.slideId;
      if (!receivedSlideId) return;

      setSlideId(receivedSlideId); // always update

      // 🔁 Always re-fetch for every slideId received
      fetch("https://d2bwumaosaqsqc.cloudfront.net/api/v1/data/slidedisplay/get-slide-info", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ GenSlideID: receivedSlideId }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data?.FormID && data?.outline_id) {
            setFormID(data.FormID);
            setOutlineId(data.outline_id);
            setSlideDataId(data.slideData_id);
            setSectionName(data.SectionName);
            setIsGenSlideValid(true);
          } else {
            setIsGenSlideValid(false); // invalid if blank slide or not in DB
          }
        })
        .catch((error) => {
          console.error("Error fetching slide info:", error);
          setIsGenSlideValid(false);
        });
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, [authToken]);


  useEffect(() => {
  const fetchFormIdByPresentationId = async () => {
    const presentationId = sessionStorage.getItem("presentationId");
    if (!presentationId) {
      console.warn("No presentationId found in sessionStorage.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/getFormIdByPresentationId`,
        { PresentationID: presentationId },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.data?.success && response.data?.FormID) {
        setFallbackFormID(response.data.FormID);
        console.log("✅ Fallback FormID loaded:", response.data.FormID);
      } else {
        console.warn("⚠️ No FormID found for the given PresentationID");
      }
    } catch (error) {
      console.error("❌ Error fetching fallback FormID:", error);
    }
  };

  fetchFormIdByPresentationId();
}, [authToken]);

const [isNew,setIsNew] = useState(false)

const handleSubmit = async () => {
  const outlineID = generateOutlineID();
  let finalFormID = formID || fallbackFormID;
  const presentationId = sessionStorage.getItem("presentationId") || "";
  const tempPresentationId = presentationId;

  setSubmitLoading(true);
  sessionStorage.setItem("isNewPresentation", "false");

  // Case 1: New presentation (no FormID)
  if (!finalFormID) {
    setIsNew(true);
    sessionStorage.setItem("isNewPresentation", "true");
    sessionStorage.setItem("presentationId", presentationId|| tempPresentationId);

    // Set session storage and notify
    sessionStorage.setItem("outlineId", outlineID);
    sessionStorage.setItem("sectionName", title);

    toast.success("Outline created successfully!");
    setShowModal(false);

    // Small delay to let toast render before opening modal
    setTimeout(() => {
      window.parent.postMessage({
        type: "openPptModal",
        outlineId,
        sectionName: title,
        isNew: true,
        presentationId: tempPresentationId,
          source: "addSlide"
      }, "*");
    }, 400);

    setSubmitLoading(false);
    return;
  }

  // Case 2: Existing presentation
  const payload = { documentId: finalFormID, title, outlineID };

  try {
    await axios.post(
      "https://d2bwumaosaqsqc.cloudfront.net/api/v1/outline/blocklist/insertbottom",
      payload,
      { headers: { Authorization: `Bearer ${authToken}` } }
    );

    toast.success("Outline created successfully!");
    setShowModal(false);

    sessionStorage.setItem("outlineId", outlineID);
    sessionStorage.setItem("sectionName", title);

    setTimeout(() => {
      window.parent.postMessage({
        type: "openPptModal",
        outlineId,
        sectionName: title,
        isNew: false,
        presentationId: sessionStorage.getItem("presentationId") || tempPresentationId,
            source: "addSlide"
      }, "*");
    }, 400);

  } catch (error: any) {
    console.error("Error inserting outline:", error);
    const errorMessage = error?.response?.data?.message || "";

    if (
      errorMessage.includes("invalid document") ||
      errorMessage.includes("Document not found")
    ) {
      toast.error("This is not a Zynth generated slide. Please use Add new slide");
    } else {
      toast.error("Failed to create outline.");
    }
  } finally {
    setSubmitLoading(false);
  }
};

  
  const [selectedText, setSelectedText] = useState<string>("");
  

useEffect(() => {
  const handleSelectedText = (event: MessageEvent) => {
    if (event.data?.type === "selectedText") {
      setSelectedText(event.data.text || "");
      console.log("✅ Received selected text:", event.data.text);
    }
  };

  window.addEventListener("message", handleSelectedText);
  return () => window.removeEventListener("message", handleSelectedText);
}, []);
useEffect(() => {
  const handleMessage = (event: MessageEvent) => {
    if (event.data?.type === "setSessionData") {
      const { presentationId, userEmail, userDP } = event.data.data || {};
      console.log("📥 Received session data from parent:", event.data.data);

      if (presentationId && userEmail) {
        sessionStorage.setItem("presentationId", presentationId);
        sessionStorage.setItem("userEmail", userEmail);
        sessionStorage.setItem("userDP", userDP);

        // ✅ Notify parent that iframe is ready
        window.parent.postMessage({ type: "refineIframeReady" }, "*");

        // ✅ Now run your actual init logic here
        window.location.reload(); // or trigger init fetch
      }
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, []);



  useEffect(() => {
   
    // if (!presentationId) {
    //   console.error("No presentationId found in session.");
    //   setPresentationExists(false);
    //   return;
    // }

    const checkPresentation = async () => {
    const presentationId = sessionStorage.getItem("presentationId");
    console.log("Checking Presentation ID:", presentationId);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/slidedisplay/checkPresentationIdExists`,
          { PresentationID: presentationId },
          { headers: { Authorization: `Bearer ${authToken}` } }
        );

        setPresentationExists(response.data.exists);
      } catch (error) {
        console.error("Error checking presentation ID:", error);
        setPresentationExists(false);
      }
    };

    const timer = setTimeout(() => {
      checkPresentation();
    }, 5000); // Changed to 3 seconds

    return () => clearTimeout(timer);
  }, [authToken]);
if (activeRefineMode === "rewrite") {
  return (
    <Suspense fallback={<RefineSkeleton />}>
      <RewriteRefinePanel
        selectedText={selectedText}
        onBack={() => setActiveRefineMode(null)}
      />
    </Suspense>
  );
}


if (activeRefineMode === "tone") {
  return (
    <Suspense fallback={<RefineSkeleton />}>
    <ToneAudiencePanel
      selectedText={selectedText}
      onBack={() => setActiveRefineMode(null)}
    />
    </Suspense>
  );
}

if (activeRefineMode === "image-generate") {
  return (
  <Suspense fallback={<RefineSkeleton />}>
  <ImageGeneratorPanel onBack={() => setActiveRefineMode(null)} />;
  </Suspense>
  )
}

if (activeRefineMode === "image-search") {
  return (
  <Suspense fallback={<RefineSkeleton />}>
  <ImageSearchPanel onBack={() => setActiveRefineMode(null)} />
  </Suspense>
);
}


return loading? (
  <RefinePresentationSkeleton/>
):(
  
  <div className="relative flex flex-col items-center justify-start min-h-screen">
    {showProfile && (
      <UserProfileModal
        isOpen={showProfile}
        onClose={() => setshowProfile(false)}
      />
    )}

    <div className="flex items-center justify-between text-base w-full px-3 py-2 mb-6 mt-4">
      <img src={zynthtext} alt="Zynth Logo" className="h-5" />
      <button
        onClick={() => setshowProfile(true)}
        className="flex items-center gap-1"
      >
        <FaUser />
        <span>Profile</span>
      </button>
    </div>

    <div className="w-full flex items-center px-1 mb-2 mt-6 relative"
    onMouseEnter={() => slideLimitReached && setSlideLimitReachedToolTip(true)}
  onMouseLeave={() => setSlideLimitReachedToolTip(false)}
    >
      <div   className={`w-full flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-2 gap-4 ${slideLimitReached ? "cursor-not-allowed":""}`}>
        <div className="flex items-center justify-between text-base w-full">
          <h3 className="font-semibold">Add new slide</h3>
          <button
            // title="addnewslide"
            onClick={handleAddNewSlide}
            disabled={slideLimitReached}
            className={`group flex items-center justify-center border border-blue-500 hover:border-blue-500 hover:border-2 p-2 hover:bg-blue-500 rounded transition-colors ${slideLimitReached ? "cursor-not-allowed":"cursor-pointer"}`}
          >
            <FaPlus className="text-gray-700 group-hover:text-white" />
          </button>
        </div>
        <div className="flex items-center justify-between text-base w-full">
          <h3 className="font-semibold">Create new version</h3>
          <button
            // title="create"
            onClick={handleCreatePresentation}
            className={`group flex items-center justify-center border ${
              isGenSlideValid
                ? "border-blue-500 hover:border-blue-500 hover:border-2 hover:bg-blue-500"
                : "border-gray-300 bg-gray-200 cursor-not-allowed"
            }
            ${slideLimitReached ? "cursor-not-allowed":"cursor-pointer"}
            p-2 rounded transition-colors`}
            disabled={!isGenSlideValid}
          >
            <FaSyncAlt
              className={`$${
                isGenSlideValid ? "text-gray-700 group-hover:text-white" : "text-gray-400"
              }`}
            />
          </button>
        </div>
      </div>
      {slideLimitReachedToolTip && (
         <div
    className="absolute left-1/2 top-[90%]  transform -translate-x-1/2 w-64 p-3 text-xs rounded-lg shadow-lg transition-opacity duration-300 z-50"
    style={{
      backgroundColor: Theme.colors.grounding,
      color: Theme.colors.background,
      zIndex: 9999,
    }}
  >
       
        <p>
          Slide limit reached. Please <span onClick={handleUpgrade}   className="underline" style={{
            color:Theme.colors.primary
          }}>upgrade</span> to add more slides.
        </p>
      </div>
      )}
    </div>

    <div className="w-full flex items-center px-1 mt-6 mb-4 relative">
      <div className="w-full flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-2 gap-4 min-h-40">
        <div className="flex justify-between items-center">
          <h3 className="text-start font-semibold">Edit Text on Slide</h3>
        </div>
        <div className="flex justify-between items-center gap-4">
          <button
            onClick={() => setActiveRefineMode("rewrite")}
            className="flex flex-col items-center justify-center border border-blue-500 rounded w-1/2 py-4 bg-white text-gray-700 hover:bg-blue-50"
          >
            <span className="text-base font-medium">Rewrite &</span>
            <span className="text-base font-medium">Refine</span>
          </button>
          <button
            onClick={() => setActiveRefineMode("tone")}
            className="flex flex-col items-center justify-center border border-blue-500 rounded w-1/2 py-4 bg-white text-gray-700 hover:bg-blue-50"
          >
            <span className="text-base font-medium">Tone &</span>
            <span className="text-base font-medium">Audience</span>
          </button>
        </div>
      </div>
    </div>

 <div className="w-full flex items-center px-1 mt-6 mb-4 relative">
      <div className="w-full flex flex-col border-2 bg-gray-100 border-gray-300 rounded-md p-2 gap-4 min-h-40">
        <div className="flex justify-between items-center">
          <h3 className="text-start font-semibold">Image Tools</h3>
        </div>
        <div className="flex justify-between items-center gap-4">
          <button
            onClick={() => setActiveRefineMode("image-generate")}
            className="flex flex-col items-center justify-center border border-blue-500 rounded w-1/2 py-4 bg-white text-gray-700 hover:bg-blue-50"
          >
            <span className="text-base font-medium">Generate</span>
            <span className="text-base font-medium">Images</span>
          </button>
          <button
            onClick={() => setActiveRefineMode("image-search")}
            className="flex flex-col items-center justify-center border border-blue-500 rounded w-1/2 py-4 bg-white text-gray-700 hover:bg-blue-50"
          >
            <span className="text-base font-medium">Search</span>
            <span className="text-base font-medium">Images</span>
          </button>
        </div>
      </div>
    </div>

    {showModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-md w-96 space-y-4">
          <h2 className="text-lg font-semibold text-gray-800">New Slide Details</h2>
          <input
            type="text"
            placeholder="Enter Slide Title"
            className="w-full border px-3 py-2 rounded-md"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <div className="flex justify-end gap-2 pt-4">
            <button
              onClick={() => setShowModal(false)}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={submitLoading}
              className={`px-4 py-2 rounded text-white ${
                submitLoading ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              {submitLoading ? "Creating..." : "Create Slide"}
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
  )
  


}
